import { render, staticRenderFns } from "./PResetRequestPage.vue?vue&type=template&id=7c02357f&"
import script from "./PResetRequestPage.vue?vue&type=script&lang=ts&"
export * from "./PResetRequestPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports